import React from "react";
import "./Index.css";

function Index() {
  const audioRef = React.useRef(null);
  const contentData = [
    {
      title: "Cachoeira is Portuguese for waterfall",
      description:
        "Like a waterfall, we bring life, fluidity, and natural beauty to communication. We transform how companies connect with their audiences, one genuine conversation at a time.",
    },
    {
      title: "We’ve reimagined the traditional agency model",
      description:
        "Here, everyone is a partner – from project leads to creative specialists. This isn’t just a title; it’s our foundation for unleashing creativity and fostering genuine ownership in every project we touch. True innovation flows from freedom. Great ideas emerge from passionate minds. Every voice matters, whether for a day or a decade. This is the essence of who we are and how we create impact for our clients.",
    },
    {
      title: "Your Success Story Starts Here",
      description:
        "When you partner with us, you’re choosing a communication ally who moves with agility and purpose. Our network spans local markets and global territories, bringing together world-class talent to solve your unique challenges. We don’t just adapt to change – we embrace it, turning every challenge into an opportunity for growth.",
    },
    {
      title: "Let’s Create Together",
      description:
        "In a world where collaboration is the new currency, we’re not just another agency – we’re your strategic partner in growth. Together, we’ll craft communications that resonate, engage, and deliver results. Our approach is built on understanding, shaped by expertise, and driven by a commitment to excellence.",
    },
  ];
  const playAudio = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };
  return (
    <div className="homepage-container">
      <h1>
        A <strong>Human</strong> Communication Agency
      </h1>
      <div className="homepage-main-image">
        <img src="/images/homeMainImage.jpg" alt="Home Main Journalists" />
      </div>

      <div className="homepage-image-desc">
        <div
          className="sound-icon"
          onClick={playAudio}
          style={{ cursor: "pointer" }}
        >
          <i className="bi bi-volume-up-fill"></i>
        </div>
        <audio ref={audioRef} src="/audio/pronunciation_audio.mp3" />
        <div className="image-desc-content">
          <h2>Cachoeira</h2>
          <p>substantivo feminino</p>
          <p className="second-desc-image">Pronounced /kɐˈʃwɐj.ɾɐ/</p>
        </div>
      </div>
      <div className="homepagethird-section">
        <div className="homepagethird-content">
          <h3>
            "A waterfall cannot be silent, just as the wisdom.
            <br />
            When they speak, the voice of power speaks”
          </h3>
          <p>Mehmet Murat ildan</p>
        </div>
      </div>
      <div className="homepage-listContent-container">
        <div className="lineimage">
          <img
            className="desktop-line-image"
            src="/images/homepageimageline.svg"
            alt="design"
          />
          <img
            className="desktop-line-image-blue"
            src="/images/homepagemobile.svg"
            alt="design"
          />
          <img
            className="mobile-line-image"
            src="/images/homepagemobile.svg"
            alt="design"
          />
        </div>
        <h4>
          Where <strong>Human Connection</strong>
          <br />
          Flows Into <strong>Business Success</strong>
        </h4>
        <div className="homepaye-listcontent">
          {contentData.map((item, index) => (
            <div key={index} className={`homepage-listItem item-${index + 1}`}>
              <h5>{item.title}</h5>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="homepage-finalsection">
        <div className="homepage-final-content">
          <p>Your Story of</p>
          <p>
            <strong>Transformation</strong>
          </p>
          <p>Begins Here.</p>
        </div>
      </div>
    </div>
  );
}

export default Index;
